/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import BaseControl from 'scripts/base-control';
import localStorageService from 'scripts/services/localstorage-service';
import appContext from 'scripts/app-context';
import FeedService from 'scripts/services/base-feed-service';
import dateTimeUtil from 'scripts/utils/date-time';
import dtm from 'scripts/services/dtm';

const liveAlertUrl = window.globalSettings.feeds.liveAlertUrl;

export var LiveAlert = BaseControl.extend({
    init: function () {
        this._super();
        this.alertData = null;
        this.alertParent = this.element.closest('.s-pop-out-video-live-alerts');
        this.alertCtaLink = this.element.find('.s-btn-watch-live');
        this.isCqEditMode = this.options.wcmMode && this.options.wcmMode == 'EDIT';

        if (this.isCqEditMode) {
            this.alertParent.addClass('cq-edit-mode');
        }

        this.liveAlertService = new FeedService(liveAlertUrl, false, true)
            .on('data', (type, data) => {
                if (data && data.id) {
                    if (this.alertData && this.alertData.id == data.id) {
                        return;
                    }

                    this.alertData = data;
                    this.showAlert();
                } else if (this.alertData) {
                    this.handleClosing();
                }
            })
            .on('error', (error) => {
                console.error('Error live alert data', error);
            });
        this.liveAlertService.fetch();
    },
    showAlert: function() {
        this.channelId = this.alertData.channelId;
        
        if ((this.isViewed() || !this.alertData.alertOn) && !this.isCqEditMode) {
            return;
        } else {
            this.updateAlertData();

            if (!this.isCqEditMode) {
                dtm.trackAmexLoad();
            }

            this.alertParent.show();
        }
    },
    updateAlertData: function() {
        if (this.alertData.ctaLink && this.alertData.ctaLink.visible) {
            this.alertCtaLink.text(this.alertData.ctaLink.title).show();
        }
        this.element.find('.s-live-alert__description').text(this.alertData.alertText);
    },
    closeAlert: function() {
        let viewedAlerts = localStorageService.getItem('viewedAlerts');

        if (viewedAlerts) {
            viewedAlerts.push(this.alertData.id);
            localStorageService.setItem('viewedAlerts', viewedAlerts);
        } else {
            localStorageService.setItem('viewedAlerts', [this.alertData.id]);
        }

        this.alertData = null;
        this.alertParent.hide();
    },
    isViewed: function() {
        let viewedAlerts = localStorageService.getItem('viewedAlerts');
        return viewedAlerts && viewedAlerts.length && viewedAlerts.indexOf(this.alertData.id) != -1;
    },
    handleClosing: function() {
        if (!this.isCqEditMode) {
            this.closeAlert();
        }
    },
    '.s-btn-close click': function() {
        this.handleClosing();
    },
    '.s-right-box .s-btn-watch-live click': function() {
        this.handleClosing();
        appContext.model.dispatch('live-alert-watch', [this.channelId]);
    },
    destroy: function() {
        if (this.liveAlertService) {
            this.liveAlertService.destroy();
            this.liveAlertService = null;
        }
    }
});
